import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
} from "@mui/material";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

const StoreTransitDetailsPop = ({ open, handleClose, Indentdata, postTransmitDetails }) => {
    const [formData, setFormData] = useState({
        contactPerson: "",
        mobileNo: "",
        trackingId: "",
    });

    const handleChange = (e) => {
        if (e.target.name === "mobileNo") {
            if (e.target.value === "" || (CommonValidation.numberOnly(e.target.value) && e.target.value?.length <= 10)) {
                setFormData({ ...formData, [e.target.name]: e.target.value });
            }
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });

        }
    };

    const handleClear = () => {
        setFormData({ contactPerson: "", mobileNo: "", trackingId: "" });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={false} // Disable default max width
            PaperProps={{
                style: {
                    width: "35dvw", // Custom width as requested
                },
            }}
        >
            <DialogTitle style={{ fontWeight: "bold", fontSize: "1.2dvw" }}>
                Transit Details
            </DialogTitle>
            <DialogContent>
                {/* Contact Details */}
                <Box
                    style={{
                        display: "flex",
                        gap: "1.5dvw",
                        marginBottom: "2dvw",
                        borderBottom: "0.1dvw solid #ddd",
                        paddingBottom: "1dvw",
                    }}
                >
                    <Box style={{ flex: 1 }}>
                        <Typography
                            style={{
                                fontSize: "1dvw",
                                color: "#666",
                                marginBottom: "0.5dvw",
                            }}
                        >
                            Contact Person Name *
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name="contactPerson"
                            value={formData.contactPerson}
                            onChange={handleChange}
                            inputProps={{ style: { fontSize: "1dvw", padding: "0.8dvw" }, maxLength: 40 }}
                        />
                    </Box>
                    <Box style={{ flex: 1 }}>
                        <Typography
                            style={{
                                fontSize: "1dvw",
                                color: "#666",
                                marginBottom: "0.5dvw",
                            }}
                        >
                            Mobile No *
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name="mobileNo"
                            value={formData.mobileNo}
                            onChange={handleChange}
                            inputProps={{ style: { fontSize: "1dvw", padding: "0.8dvw" }, maxLength: 10 }}
                            error={formData.mobileNo.length !== 10 && formData.mobileNo.length > 0}
                        />
                    </Box>
                </Box>

                {/* Tracking Details */}
                <Box>
                    <Typography
                        style={{
                            fontSize: "1.2dvw",
                            fontWeight: "bold",
                            marginBottom: "1dvw",
                        }}
                    >
                        Tracking Details
                    </Typography>
                    <Box>
                        <Typography
                            style={{
                                fontSize: "1dvw",
                                color: "#666",
                                marginBottom: "0.5dvw",
                            }}
                        >
                            Tracking ID
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name="trackingId"
                            value={formData.trackingId}
                            onChange={handleChange}
                            inputProps={{ style: { fontSize: "1dvw", padding: "0.8dvw" }, maxLength: 40 }}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions style={{ padding: "2dvw" }}>
                <Button
                    onClick={handleClear}
                    variant="outlined"
                >
                    Clear
                </Button>
                <Button
                    onClick={() => postTransmitDetails({
                        contactPerson: formData.contactPerson,
                        mobileNo: formData.mobileNo,
                        trackingId: formData.trackingId,
                    })}
                    variant="contained"
                    disabled={!formData.contactPerson || formData.mobileNo?.length !== 10}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StoreTransitDetailsPop;
